import { useState, useEffect } from "react"
import { api } from '../utils/api'

export default function EditCustomerModal({ open, onClose, customer, onEditCustomer }) {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    address: '',
    creditLimit: '',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  useEffect(() => {
    if (customer) {
      setForm({
        name: customer.name || '',
        phone: customer.phone || '',
        address: customer.address || '',
        creditLimit: customer.creditLimit || '',
      })
    }
  }, [customer])

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError("")
    try {
      const res = await api.put(`/customers/${customer.id}`, { ...form, creditLimit: Number(form.creditLimit) })
      if (onEditCustomer) onEditCustomer(res.data.data)
      onClose()
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to update customer')
    } finally {
      setLoading(false)
    }
  }

  if (!open) return null

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        <div className="bg-white rounded-lg shadow-xl p-6 z-10 w-full max-w-md">
          <h2 className="text-xl font-bold mb-4">Edit Customer</h2>
          {error && <div className="mb-2 text-red-600">{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Name</label>
              <input type="text" name="name" value={form.name} onChange={handleChange} className="w-full border rounded px-3 py-2" required />
            </div>
            <div>
              <label className="block text-sm font-medium">Phone</label>
              <input type="text" name="phone" value={form.phone} onChange={handleChange} className="w-full border rounded px-3 py-2" required />
            </div>
            <div>
              <label className="block text-sm font-medium">Address</label>
              <input type="text" name="address" value={form.address} onChange={handleChange} className="w-full border rounded px-3 py-2" required />
            </div>
            <div>
              <label className="block text-sm font-medium">Credit Limit</label>
              <input type="number" name="creditLimit" value={form.creditLimit} onChange={handleChange} className="w-full border rounded px-3 py-2" />
            </div>
            <div className="flex justify-end gap-2">
              <button type="button" className="px-4 py-2 bg-gray-300 rounded" onClick={onClose}>Cancel</button>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded" disabled={loading}>{loading ? 'Saving...' : 'Save'}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
} 